export * from "./TriviaLarge";
export * from "./TriviaMedium";
export * from "./TriviaScore";
